var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningLightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18c-.621 0-.956-.346-.968-.98l-.161-6.308c-.012-.633.454-1.087 1.123-1.087.657 0 1.147.466 1.135 1.1l-.173 6.295c-.012.645-.358.98-.956.98zm.006 4.208c-.717 0-1.338-.573-1.338-1.279 0-.705.609-1.29 1.338-1.29.73 0 1.338.573 1.338 1.29s-.621 1.28-1.338 1.28z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 25.177c5.01 0 9.177-4.176 9.177-9.177 0-5.009-4.174-9.177-9.188-9.177-4.998 0-9.166 4.165-9.166 9.177 0 5 4.177 9.177 9.177 9.177zM27 16c0 6.007-4.982 11-11 11-6.007 0-11-4.993-11-11C5 9.982 9.983 5 15.99 5 22.006 5 27 9.982 27 16z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLightCircle);
export default __webpack_public_path__ + "static/media/Warning-Light_Circle.e4a3bbb3856d113a0610690f368fa58a.svg";
export { ForwardRef as ReactComponent };